<template>
  <div class="main-panel">
    <transition name="fade" mode="out-in">
      <keep-alive>
        <router-view />
      </keep-alive>
    </transition>
  </div>
</template>
<script>
  export default {};
</script>
<style>
</style>
